export default __webpack_public_path__ + "static/media/avatar-normal-geometric-1.24b306b4.svg";